import React, { ChangeEvent } from 'react';
import { FormField } from './FormField';

interface TextAreaFieldProps {
    id: string;
    label: string;
    value: string | null | undefined;
    onChange: (value: string) => void;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    tooltip?: string;
    error?: string;
    className?: string;
    rows?: number;
}

export const TextAreaField: React.FC<TextAreaFieldProps> = ({
    id,
    label,
    value,
    onChange,
    required = false,
    disabled = false,
    placeholder,
    tooltip,
    error,
    className = '',
    rows = 3
}) => {
    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        onChange(e.target.value);
    };

    return (
        <FormField
            label={label}
            id={id}
            required={required}
            tooltip={tooltip}
            error={error}
        >
                        <textarea
                id={id}
                className={`form-control ${className}`}
                value={value || ''}
                onChange={handleChange}
                disabled={disabled}
                placeholder={placeholder}
                rows={rows}
            />
        </FormField>
    );
};
